let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("amAvE")).then(() => parcelRequire('eiQQV'));